<template>
  <!--应用管理-->
  <div id="applicationList">
    <div style="padding: 20px">
      <div class="userDetail bot_bottom">
        <div>
          <span>姓名</span>
          <span>{{ myDetail.cdwD_DOCCode ?  myDetail.cdwD_DOCName : myDetail.docName}}</span>
        </div>
        <div>
          <span>医院</span>
          <span>{{myDetail.cdwD_DOCCode ? myDetail.cdwD_InstName : myDetail.instName}}</span>
        </div>
        <div>
          <span>科室</span>
          <span>{{myDetail.cdwD_DOCCode ? myDetail.cdwD_Department : myDetail.department}}</span>
        </div>
        <div>
          <span>省份</span>
          <span>{{myDetail.cdwD_DOCCode ? myDetail.cdwD_Province : myDetail.province}}</span>
        </div>
        <div>
          <span>城市</span>
          <span>{{myDetail.cdwD_DOCCode ? myDetail.cdwD_City : myDetail.city}}</span>
        </div>
        <div>
          <span>学术职称</span>
          <span>{{myDetail.title}}</span>
        </div>
        <div>
          <span>职务</span>
          <span>{{myDetail.profTitle}}</span>
        </div>
        <!-- <div>
          <span>是否KOL</span>
          <span>{{myDetail.isKOL ? '是' : '否'}}</span>
        </div> -->
        <div>
          <span>K级医生</span>
          <span>{{myDetail.k_SEGMENT}}</span>
        </div>
        <!-- <div style="width: 70%">
          <span>K级医生理由</span>
          <span>{{myDetail.k_Medical_Reason}}</span>
        </div> -->
        <div>
          <span>是否认证</span>
          <span>{{myDetail.hcpType === 'Import' || myDetail.hcpType === 'RealTimeSync' || myDetail.hcpType === 'eContract' ? '已认证' : '未认证'}}</span>
        </div>
        <div>
          <span>是否关注</span>
          <span>{{myDetail.isFollowed ? '是' : '否'}}</span>
        </div>
        <div>
          <span>关注时间</span>
          <span>{{myDetail.subTime ? $commonJs.returnNewDate(myDetail.subTime) : ''}}</span>
        </div>
        <div>
          <span>注册时间</span>
          <span>{{myDetail.regTime ? $commonJs.returnNewDate(myDetail.regTime) : ''}}</span>
        </div>
        <div style="width: 44.3%">
          <span>感兴趣的领域</span>
          <span><b style="vertical-align: middle;display: inline-block" :key="index" v-for="(item, index) in myDetail.fields"><b v-if="index !== 0">, </b><b style="font-weight: normal">{{item.name}}</b></b></span>
        </div>
        <div style="width: 44.3%">
          <span>感兴趣的适应症</span>
          <span><b style="vertical-align: middle;display: inline-block" :key="index" v-for="(item, index) in myDetail.indicationInfos"><b v-if="index !== 0">, </b><b style="font-weight: normal">{{item.name}}</b></b></span>
        </div>
      </div>
      <div class="artileList">
        <nav class="m_t_10 m_b_10"><i style="background-color: #00b7ee" class="VioletDot"></i><abbr class="font16">产品信息</abbr></nav>
        <div style="max-height: 600px;overflow: auto">
          <table cellspacing="0" class="allTable">
            <thead>
            <tr>
              <th>产品代码</th>
              <th>产品名</th>
              <th>评级</th>
            </tr>
            </thead>
            <tbody v-if="productList.length > 0">
            <tr :key="index" v-for="(item, index) in productList">
              <td>{{item.prodcode}}</td>
              <td>{{item.prodname}}</td>
              <td>{{item.rating}}</td>
            </tr>
            </tbody>
            <tbody v-else>
            <tr class="t_c">
              <td colspan="5" class="colorZh" style="font-size: 14px!important;">暂无数据</td>
            </tr>
            </tbody>
          </table>
        </div>

      </div>
      <div class="artileList">
        <nav class="m_t_10 m_b_10"><i class="VioletDot"></i><abbr class="font16">阅读文章列表</abbr></nav>
        <div style="max-height: 600px;overflow: auto">
          <table cellspacing="0" class="allTable">
            <thead>
            <tr>
              <th>文章标题</th>
              <th>阅读总时长(s)</th>
              <th>是否转发</th>
              <th>是否收藏</th>
              <th>是否点赞</th>
            </tr>
            </thead>
            <tbody v-if="articleList.length > 0">
            <tr :key="index" v-for="(item, index) in articleList">
              <td @click="openDetail(item)" class="NoWrap" style="max-width: 300px"><b style="font-weight: normal;text-decoration: underline;cursor:pointer;">{{item.title}}</b></td>
              <td>{{item.readTime}}</td>
              <td>{{item.forwards ? '是' : '否'}}</td>
              <td>{{item.isFav ? '是' : '否'}}</td>
              <td>{{item.isLike ? '是' : '否'}}</td>
            </tr>
            </tbody>
            <tbody v-else>
            <tr class="t_c">
              <td colspan="5" class="colorZh" style="font-size: 14px!important;">暂无数据</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="artileList">
        <nav class="m_t_10 m_b_10"><i style="background-color: #ff0000" class="VioletDot"></i><abbr class="font16">参会记录</abbr></nav>
        <div style="max-height: 600px;overflow: auto">
          <table cellspacing="0" class="allTable">
            <thead>
            <tr>
              <th>会议名称</th>
              <th>会议描述</th>
              <th>会议开始时间</th>
              <th>会议结束时间</th>
            </tr>
            </thead>
            <tbody v-if="meetingList.length > 0">
            <tr :key="index" v-for="(item, index) in meetingList">
              <td class="NoWrap" style="max-width: 300px"><b @click="getMeetingDetail(item.id, item.openId)" style="font-weight: normal;text-decoration: underline;cursor:pointer;">{{item.name}}</b></td>
              <td v-html="item.description">{{item.description}}</td>
              <td>{{item.beginTime ? item.beginTime.split('.')[0].replace('T', ' ') : ''}}</td>
              <td>{{item.endTime ? item.endTime.split('.')[0].replace('T', ' ') : ''}}</td>
            </tr>
            </tbody>
            <tbody v-else>
            <tr class="t_c">
              <td colspan="5" class="colorZh" style="font-size: 14px!important;">暂无数据</td>
            </tr>
            </tbody>
          </table>
        </div>

      </div>
    </div>
    <!--内容列表-新建内容-->
    <contentPreview :forType="'contentReadAll'" :contentId="previewContentId" v-model="coverShow"></contentPreview>
    <model v-if="showModel" :buttonType="3" :title="'会议详情'" :minWidth="'900px'" v-on:on-cancel="cancelModel()" v-on:on-confirm="confirModel()">
      <div style="padding: 20px">
        <div class="artileList">
          <nav class="m_t_10 m_b_10"><i style="background-color: #ff0000" class="VioletDot"></i><abbr class="font16 f_w">签到</abbr></nav>
          <div style="padding: 20px 0">
            <span style="vertical-align: top">签到时间</span><span style="margin-left: 20px;vertical-align: top">{{meetingDetail.signDetail.signTime ? meetingDetail.signDetail.signTime.split('.')[0].replace('T', ' ') : ''}}</span>
          </div>
        </div>
        <div class="artileList">
          <nav class="m_t_10 m_b_10"><i style="background-color: #00a0e9" class="VioletDot"></i><abbr class="font16 f_w">投票</abbr></nav>
          <table cellspacing="0" class="allTable">
            <thead>
            <tr>
              <th>投票名称</th>
              <th>投票选项名称</th>
              <th>投票时间</th>
            </tr>
            </thead>
            <tbody v-if="meetingDetail.voteList.length > 0">
            <tr :key="index" v-for="(item, index) in meetingDetail.voteList">
              <td class="NoWrap" style="max-width: 300px">{{item.voteName}}</td>
              <td v-html="item.voteItemName">{{item.voteItemName}}</td>
              <td>{{item.vrDate ? item.vrDate.split('.')[0].replace('T', ' ') : ''}}</td>
            </tr>
            </tbody>
            <tbody v-else>
            <tr class="t_c">
              <td colspan="5" class="colorZh" style="font-size: 14px!important;">暂无数据</td>
            </tr>
            </tbody>
          </table>
        </div>
        <div class="artileList">
          <nav class="m_t_10 m_b_10"><i style="background-color: #78AB46" class="VioletDot"></i><abbr class="font16 f_w">调研</abbr></nav>
          <table cellspacing="0" class="allTable">
            <thead>
            <tr>
              <th>调研名称</th>
              <th>调研选项名称</th>
              <th>选项内容</th>
              <th>分数</th>
              <th>结果时间</th>
              <th>分数权重</th>
            </tr>
            </thead>
            <tbody v-if="meetingDetail.survery.length > 0">
            <tr :key="index" v-for="(item, index) in meetingDetail.survery">
              <td class="NoWrap" style="max-width: 300px">{{item.surveyName}}</td>
              <td v-html="item.surveyItemName">{{item.surveyItemName}}</td>
              <td >{{item.optionText}}</td>
              <td >{{item.sgrade}}</td>
              <td>{{item.vsDate ? item.vsDate.split('.')[0].replace('T', ' ') : ''}}</td>
              <td >{{item.weight}}</td>
            </tr>
            </tbody>
            <tbody v-else>
            <tr class="t_c">
              <td colspan="5" class="colorZh" style="font-size: 14px!important;">暂无数据</td>
            </tr>
            </tbody>
          </table>
        </div>
        <div class="artileList">
          <nav class="m_t_10 m_b_10"><i class="VioletDot"></i><abbr class="font16 f_w">话题</abbr></nav>
          <table cellspacing="0" class="allTable">
            <thead>
            <tr>
              <th>话题描述</th>
              <th>问题内容</th>
              <th>回复内容</th>
              <th>创建时间</th>
            </tr>
            </thead>
            <tbody v-if="meetingDetail.topicList.length > 0">
            <tr :key="index" v-for="(item, index) in meetingDetail.topicList">
              <td class="NoWrap" style="max-width: 300px">{{item.description}}</td>
              <td v-html="item.questionBody">{{item.questionBody}}</td>
              <td class="contentBody" v-html="item.body">{{item.body}}</td>
              <td>{{item.createDate ? item.createDate.split('.')[0].replace('T', ' ') : ''}}</td>
            </tr>
            </tbody>
            <tbody v-else>
            <tr class="t_c">
              <td colspan="5" class="colorZh" style="font-size: 14px!important;">暂无数据</td>
            </tr>
            </tbody>
          </table>
        </div>
        <div class="artileList">
          <nav class="m_t_10 m_b_10"><i style="background-color: #ff0000" class="VioletDot"></i><abbr class="font16 f_w">点赞</abbr></nav>
          <div style="padding: 20px 0">
            <span style="vertical-align: top">点赞时间</span><span style="margin-left: 20px;vertical-align: top">{{meetingDetail.likeList.createDate ? meetingDetail.likeList.createDate.split('.')[0].replace('T', ' ') : ''}}</span>
          </div>
        </div>
        <div class="artileList">
          <nav class="m_t_10 m_b_10"><i style="background-color: #ffe89d" class="VioletDot"></i><abbr class="font16 f_w">直播</abbr></nav>
          <div style="padding: 20px 0">
            <span style="vertical-align: top">参会时间</span><span style="margin-left: 20px;vertical-align: top">{{meetingDetail.zbList.joinTime ? meetingDetail.zbList.joinTime.split('.')[0].replace('T', ' ') : ''}}</span>
            <span style="vertical-align: top;margin-left: 20px;">离会时间</span><span style="margin-left: 20px;vertical-align: top">{{meetingDetail.zbList.leaveTime ? meetingDetail.zbList.leaveTime.split('.')[0].replace('T', ' ') : ''}}</span>
          </div>
        </div>
      </div>
    </model>
  </div>
</template>

<script>
import contentPreview from '../../myComponents/contentPreview'
export default {
  name: 'applicationList',
  data () {
    return {
      coverShow: false,
      id: this.$route.query.id,
      previewContentId: 0,
      myList: [],
      myDetail: {},
      showModel: false,
      tabSwitch: 1,
      articleList: [],
      productList: [],
      meetingList: [],
      meetingDetail: {
        signDetail: {},
        voteList: [],
        survery: [],
        topicList: [],
        likeList: {},
        zbList: {}
      }
    }
  },
  created () {
    this.getDetail()
    this.getProductList()
    this.getMeetingList()
  },
  methods: {
    getMeetingDetail (id) {
      this.showModel = true
      this.$axiox.get(`/api/hcp/sign/${this.id}/${id}`).then(msg => {
        this.meetingDetail.signDetail = msg || {}
      })
      this.$axiox.get(`/api/hcp/vote/${this.id}/${id}`).then(msg => {
        this.meetingDetail.voteList = msg || []
      })
      this.$axiox.get(`/api/hcp/survey/${this.id}/${id}`).then(msg => {
        this.meetingDetail.survery = msg || []
      })
      this.$axiox.get(`/api/hcp/topic/${this.id}/${id}`).then(msg => {
        this.meetingDetail.topicList = msg || []
      })
      this.$axiox.get(`/api/hcp/like/${this.id}/${id}`).then(msg => {
        this.meetingDetail.likeList = msg || {}
      })
      this.$axiox.get(`/api/hcp/zb/${this.id}/${id}`).then(msg => {
        this.meetingDetail.zbList = msg || {}
      })
    },
    openDetail (item) {
      this.previewContentId = item.articleID
      this.coverShow = true
    },
    editApp (id, type) {
      this.$router.push({
        path: 'sysConfigEdit/' + id,
        query: {
          type: type
        }
      })
    },
    getDetail () {
      this.$axiox.get('/api/hcp/query/' + this.id).then(msg => {
        this.myDetail = msg
        this.getArticleList()
      })
    },
    getArticleList () {
      let data = {
        openId: this.myDetail.openId
      }
      this.$axiox.post('/api/ArticlDoctor/article', data).then(msg => {
        this.articleList = msg
      })
    },
    getProductList () {
      this.$axiox.get('/api/hcp/product/' + this.id).then(msg => {
        this.productList = msg
      })
    },
    getMeetingList () {
      this.$axiox.get('/api/hcp/meeting/' + this.id).then(msg => {
        this.meetingList = msg
      })
    },
    confirModel () {
    },
    cancelModel () {
      this.showModel = false
    },
    newApplicationList () {
      this.$commonJs.doubleComfirm({
        content: '您确认发布更新后的使用行为规范吗？重新发布之后，企业微信用户将需要重新阅读和同意此条使用隐私政策以及行为规范。',
        successFun: msg => {
          this.$axiox.put('/api/SystemSetting/PolicyFile/MergePublish', {}).then(msg => {
            this.$commonJs.alertTips({
              type: 'success',
              title: '成功',
              content: '合并发布成功',
              stayTime: 5
            })
            this.getList()
          })
        },
        errorFun: msg => {
        }
      })
    }
  },
  components: {
    'contentPreview': contentPreview
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/userManager/userDetail.vue